package ui.eReceipt

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.remember
import androidx.lifecycle.ViewModel
import globalCoroutineExceptionHandler
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.SupervisorJob
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.launch
import model.ConsumerInformationV3
import model.DataRepository
import model.MerchantFullInformationV3
import model.NavigationRepository
import model.NavigationRepository.DialogState
import navigation.NavigationState
import org.koin.compose.koinInject
import receipt.Question
import receipt.Receipt
import ui.DisposableViewModel
import ui.ScopeHolderFactory
import ui.snackbars.SnackBarState

@Composable
fun eReceiptViewModel(
    scopeHolderFactory: ScopeHolderFactory = koinInject(),
): EReceiptViewModel {
    val scopeHolder = remember { scopeHolderFactory.getOrCreate(EReceiptViewModel::class) }
    DisposableEffect(Unit) { onDispose { scopeHolder.detach() } }
    return remember { scopeHolder.attach() }
}

class EReceiptViewModel(
    private val dataRepository: DataRepository,
    private val navigationRepository: NavigationRepository
) : ViewModel(), DisposableViewModel {

    sealed class RatingType(val title: String) {
        class Thumb(title: String) : RatingType(title)
        object None : RatingType("")
    }

    private val job = SupervisorJob()
    private val viewModelScope = CoroutineScope(job + Dispatchers.Main)

    val eReceiptStateFlow: StateFlow<Receipt?> = dataRepository.eReceiptStateFlow
    val orderQuestionStateFlow: StateFlow<Question?> = dataRepository.orderQuestionStateFlow
    val merchantInformationStateFlow: StateFlow<MerchantFullInformationV3?> = dataRepository.merchantInformationStateFlow
    val consumerInformationStateFlow: StateFlow<ConsumerInformationV3?> = dataRepository.consumerInformationStateFlow
    private val dialogStateStateFlow = navigationRepository.dialogStateMutableStateFlow

    init {
        println("EReceiptViewModel has been created!")
    }

    fun cancelEnrollment(consumerLoyaltyProgramGuid: String) {
        dialogStateStateFlow.value = DialogState.CancelEnrollment {
            dialogStateStateFlow.value = DialogState.Nothing()
            if (it) {
                viewModelScope.launch(globalCoroutineExceptionHandler + Dispatchers.Default) {
                    dataRepository.cancelEnrollment(consumerLoyaltyProgramGuid)
                }
            }
        }
    }

    fun setTermsOfService() {
        navigationRepository.navigate(NavigationState.TermsOfService())
    }

    fun setPrivacyPolicy() {
        navigationRepository.navigate(NavigationState.PrivacyPolicy())
    }

    fun requestAuthenticationFromOrderPaymentGuid(orderPaymentGuid: String) {
        viewModelScope.launch(globalCoroutineExceptionHandler + Dispatchers.Default) {
            dataRepository.requestAuthenticationFromOrderPaymentGuid(orderPaymentGuid)
            navigationRepository.setSnackbarState(SnackBarState.PhoneNumberAuthRequested())
        }
    }

    fun isTokenAvailable(): Boolean {
        return !dataRepository.getToken().isNullOrEmpty()
    }

    fun answerQuestion(orderPaymentGuid: String, questionId: Int, score: Int) {
        dataRepository.answerQuestion(orderPaymentGuid, questionId, score)
    }



    override fun dispose() {
        println("EReceiptViewModel.dispose()")
        job.cancel()
    }

}